import React from 'react'
import './notification.sass'
import {useDispatch} from 'react-redux';

export default function MobileNotification({ icon, text }) {
    const dispatch = useDispatch();

    const handleCloseNotification = () => {
        dispatch({
            type: 'SET_NOTIFICATION', payload: {
                isEnabled: false,
                text: '',
                icon: ''
            }
        })
    }
    return (
        <div className="mobile-notification">
            <div className="col-img">
                <img src={require(`../../assets/icons/${icon}`)} />
                <div className="col-content">
                {text}
            </div>
            </div>
            <div className="col-img-cross">
                <img onClick={handleCloseNotification} src={require('../../assets/icons/notifcross.svg')} />
            </div>

        </div>
    )
}
